import { render, staticRenderFns } from "./Airline.vue?vue&type=template&id=445cd6b9&"
import script from "./Airline.vue?vue&type=script&lang=js&"
export * from "./Airline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports